import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {ProductionOrderWeaving} from '@domain/production-order-lite/production-order-weaving/production-order-weaving';
import {PropertyValue} from '@domain/property-value';
import {OverviewListProductionOrderWeaving} from '@presentation/pages/texfab/production-order-lite/overview/overview-list-production-order-weaving';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ProductionOrdersWeaving} from './production-orders-weaving';

@Injectable()
export class HttpProductionOrdersWeavingService implements ProductionOrdersWeaving {
  private httpClient: HttpClient;
  private backendConfiguration: BackendConfiguration;

  public constructor(httpClient: HttpClient, backendConfiguration: BackendConfiguration) {
    this.httpClient = httpClient;
    this.backendConfiguration = backendConfiguration;
  }

  public getAll(): Observable<OverviewListProductionOrderWeaving[]> {
    return this.httpClient
      .get(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving`)
      .pipe(map((weaveProductionOrdersJSON: any) => weaveProductionOrdersJSON.map((weaveProductionOrderJSON: any) => OverviewListProductionOrderWeaving.fromJSON(weaveProductionOrderJSON))));
  }

  public getById(id: number): Observable<ProductionOrderWeaving> {
    return this.httpClient
      .get(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving/${id}`)
      .pipe(map((productionOrderWeavingJSON: any) => ProductionOrderWeaving.fromJSON(productionOrderWeavingJSON)));
  }

  public save(item: ProductionOrderWeaving): Observable<number> {
    return this.httpClient.post(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving`, item.toJSON()).pipe(map((response: {id: number}) => response.id));
  }

  public saveAndPlan(item: ProductionOrderWeaving, runId: number): Observable<number> {
    return this.httpClient
      .post(`${this.backendConfiguration.getAggregatorEndpoint()}productionorders/lite/save-and-plan`, {...item.toJSON(), runId})
      .pipe(map((response: {id: number}) => response.id));
  }

  public update(item: ProductionOrderWeaving): Observable<void> {
    return this.httpClient.put<void>(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving/${item.id}`, item.toJSON());
  }

  public updateAndPlan(item: ProductionOrderWeaving, runId: number): Observable<void> {
    return this.httpClient.put<void>(`${this.backendConfiguration.getAggregatorEndpoint()}productionorders/lite/${item.id}/save-and-plan`, {...item.toJSON(), runId});
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving/${id}`);
  }

  public checkCompatibilityWithMachine(productionOrderLiteId: number, machineId: number): Observable<number> {
    return this.httpClient.get<number>(`${this.backendConfiguration.getAggregatorEndpoint()}productionorders/lite/${productionOrderLiteId}/is-compatible-machine/${machineId}`);
  }

  public getListOfCustomSettings(): Observable<PropertyValue[]> {
    return this.httpClient.get<PropertyValue[]>(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving/custom-settings`);
  }

  public hasAlreadyAdjustedCustomSettings(): Observable<boolean> {
    return this.httpClient
      .get(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving/custom-settings/already-adjusted`)
      .pipe(map((response: {alreadyAdjustedCustomSettings: boolean}) => response.alreadyAdjustedCustomSettings));
  }

  public saveCustomSettings(chosenSettings: PropertyValue[]): Observable<void> {
    return this.httpClient.put<void>(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving/custom-settings`, chosenSettings);
  }

  public getNameGenerationProperties(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving/custom-settings/name-generation-properties`);
  }

  public generateName(item: ProductionOrderWeaving): Observable<string> {
    return this.httpClient.post<string>(`${this.backendConfiguration.getProductionOrderEndpoint()}production-orders/weaving/custom-settings/generate-name`, item.toJSON());
  }
}
